import { getPokerMin } from '@/components/images/base64/PokerMin';
import { GetPokerNumber } from '@/utils/pokerCount';
import { Grid } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { GameResultCellProps } from '..';

export const DragonTigerGameResult = (props: GameResultCellProps) => {
    const { summary } = props;
    const { t } = useTranslation();
    const tokens: number[] = summary.Result.split(',').map(str => Number(str));
    return (
        <>
            <Stack className="item-dt-game-result-container">
                <DetailResult
                    lbl={t('road.dragon_win')}
                    lblColor="#3568EE"
                    cards={[tokens[0]]}
                    point={GetPokerNumber(tokens[0])}
                />
                <DetailResult
                    lbl={t('road.tiger_win')}
                    lblColor="#F6444B"
                    cards={[tokens[1]]}
                    point={GetPokerNumber(tokens[1])}
                />
            </Stack>
        </>
    );
};

export const DetailResult = ({
    lbl,
    lblColor,
    cards,
    point,
}: {
    lbl: string;
    lblColor: string;
    cards: number[];
    point: number;
}) => {
    return (
        <Stack className="detail-container">
            <Grid item className="detail-left" color={lblColor}>
                {lbl}
            </Grid>
            {cards.map((c, i) => {
                return (
                    <Grid key={`card-${c}-${i}`} item>
                        <Stack direction="row">
                            <Grid item className="card-container">
                                {getPokerMin(c)}
                            </Grid>
                        </Stack>
                    </Grid>
                );
            })}
            <Grid item className="detail-right">
                {point}
            </Grid>
        </Stack>
    );
};
